<template>
  <div class="wrap">
    <div class="head">
      <div class="title">{{ ui.mis }}</div>
      <div class="intro">{{ ui.misIntro }}</div>
    </div>

    <div class="status-row">
      <span class="selected">{{ selectedText }}</span>
      <button v-if="store.mine.length" class="clear" @click="clearMine">{{ ui.limpiar }}</button>
    </div>

    <div v-if="store.alergenosCatalogo.length" class="catalog">
      <button
        v-for="a in store.alergenosCatalogo"
        :key="a.id"
        class="alg"
        :class="{ active: store.mine.includes(a.id) }"
        :title="a.nota || ''"
        @click="toggleMine(a.id)"
      >
        <span class="icon"><allergen-image :id="a.id" :size="40" /></span>
        <span class="name">{{ a.nombre }}</span>
        <span v-if="store.mine.includes(a.id)" class="check">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
        </span>
      </button>
    </div>

    <div v-else-if="store.booting" class="state">{{ ui.cargando }}</div>

    <div v-else class="state">
      <div class="state-title">{{ ui.errorCarga }}</div>
      <app-button variant="secondary" pill @click="loadAlergenos">{{ ui.reintentar }}</app-button>
    </div>

    <div class="actions">
      <app-button variant="primary" pill @click="gotoMenu">{{ ui.verBuffet }}</app-button>
    </div>
  </div>
</template>

<script>
import { UI } from '@/data'
import { store, toggleMine, clearMine, gotoMenu, loadAlergenos } from '@/store'
import AllergenImage from './ui/AllergenImage.vue'
import AppButton from './ui/AppButton.vue'

export default {
  name: 'MineView',
  components: { AllergenImage, AppButton },
  data() {
    return { store }
  },
  computed: {
    ui() { return UI[store.locale] || UI.es },
    selectedText() {
      return store.mine.length
        ? this.ui.selN.replace('{n}', store.mine.length)
        : this.ui.ningunoSel
    }
  },
  methods: { toggleMine, clearMine, gotoMenu, loadAlergenos }
}
</script>

<style scoped>
.wrap { max-width: 760px; margin: 0 auto; }
.head { margin-bottom: 8px; }
.title {
  font-family: var(--font-display);
  font-weight: 300;
  font-size: 1.9rem;
  color: var(--seth-navy);
  line-height: 1.1;
}
.intro {
  font-size: 0.92rem;
  color: var(--ink-700);
  margin-top: 8px;
  max-width: 52ch;
  line-height: 1.5;
}

.status-row { display: flex; gap: 10px; margin: 18px 0; flex-wrap: wrap; }
.selected { font-size: 0.85rem; color: var(--ink-500); }
.clear {
  border: none;
  background: transparent;
  color: var(--seth-sea);
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
}

.catalog {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
  margin-bottom: 28px;
}
.alg {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 18px 12px;
  border-radius: 14px;
  cursor: pointer;
  transition: all 180ms;
  background: #fff;
  border: 2px solid var(--sand-200);
}
.alg.active { background: #DCF0F2; border: 2px solid #2C9CB0; }
.icon { display: flex; color: var(--ink-500); }
.alg.active .icon { color: #2C9CB0; }
.name {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--ink-900);
  text-align: center;
  line-height: 1.2;
}
.check {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--seth-sea);
  display: flex;
  align-items: center;
  justify-content: center;
}

.actions { display: flex; gap: 12px; flex-wrap: wrap; }

.state { text-align: center; padding: 40px 20px 28px; color: var(--ink-500); }
.state-title { font-size: 0.95rem; margin-bottom: 14px; }
.state .seth-btn { margin: 0 auto; }
</style>
